import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { searchgame, searchplatform, searchchannel, searchpkg } from "@/api/dataAll/dataAll";
import { querUserList, banUser } from "@/api/loginConfig/addUserList";
import { getadvLocation } from "@/api/dataAll/advLocation";
import { restKeyId } from "@/api/loginConfig/restKey";
import adduserPage from "./components/adduserList.vue";
import bindPhone from "./components/bindPhone.vue";
import bindEmail from "./components/bindEmail.vue";
import accassDetail from "./components/accassDetail.vue";
export default {
  name: "userListPage",
  components: {
    adduserPage: adduserPage,
    bindPhone: bindPhone,
    bindEmail: bindEmail,
    accassDetail: accassDetail
  },
  data: function data() {
    return {
      advanced: false,
      dialog: false,
      num: 1,
      message: '此操作将封禁该选项, 是否继续?',
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      tableTitle: [],
      advchannels: [],
      advLocation: [],
      gameId: "",
      totalShow: true,
      searchData: {
        user_name: "",
        phone: "",
        email: "",
        device_id: "",
        game: '',
        platform: '',
        channel: '',
        advChannel: '',
        advLocation: '',
        pkg: ""
      },
      searchMark: {
        page: '',
        user_name: "",
        phone: "",
        email: "",
        device_id: "" // ad_placement: "",

      },
      total: 0,
      page: 0,
      pagrSize: 10,
      tableData: [],
      tableLtv: [],
      tableDate: "",
      show: false,
      dates: [],
      addWayConfig: false,
      addWayConfigEmail: false,
      addWayConfigPhone: false,
      addWayConfigInfor: false,
      showing: false,
      obj: {},
      datas: []
    };
  },
  created: function created() {
    var _this = this;

    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    });
  },
  methods: {
    gamechange: function gamechange(id) {
      var _this2 = this;

      if (id != "") {
        searchplatform({
          game_id: id
        }).then(function (res) {
          _this2.searchplatforms = res.data;
          _this2.searchData.platform = "";
          _this2.searchData.channel = "";
          _this2.searchData.pkg = "";
          _this2.searchMark.platform = "";
          _this2.searchMark.channel = "";
          _this2.searchMark.pkg = "";
          _this2.searchData.advChannel = "";
          _this2.searchMark.ad_placement = "";
          _this2.searchMark.ad_channel = "";
          _this2.searchchannels = [];
          _this2.advchannels = [];
          _this2.advLocation = [];
          _this2.searchpkgs = [];

          _this2.searchgames.forEach(function (item) {
            if (item.id == id) {
              _this2.searchMark.game = item.game_mark;
            }
          });
        });
      } else {
        this.searchData.platform = "";
        this.searchData.channel = "";
        this.searchData.pkg = "";
        this.searchMark.pkg = "";
        this.searchMark.platform = "";
        this.searchMark.channel = "";
        this.searchplatforms = [];
        this.searchchannels = [];
        this.searchpkgs = [];
        this.searchMark.game = "";
        this.searchData.advChannel = "";
        this.searchData.advLocation = "";
        this.searchMark.ad_channel = "";
        this.searchMark.ad_placement = "";
        this.advchannels = [];
        this.advLocation = [];
      }
    },
    platformchange: function platformchange(id) {
      var _this3 = this;

      if (id != "") {
        searchchannel({
          platform_id: id
        }).then(function (res) {
          _this3.searchchannels = res.data.channel;
          _this3.advchannels = res.data.adv_platform;
          _this3.searchData.channel = "";
          _this3.searchData.pkg = "";
          _this3.searchData.advChannel = "";
          _this3.searchData.advLocation = "";
          _this3.searchMark.channel = "";
          _this3.searchMark.pkg = "";
          _this3.searchMark.ad_placement = "";
          _this3.searchMark.ad_channel = "";
          _this3.advLocation = [];
          _this3.searchpkgs = [];

          _this3.searchplatforms.forEach(function (item) {
            if (item.id == id) {
              _this3.searchMark.platform = item.platform_mark;
              _this3.searchData.channel = "";
              _this3.searchMark.channel = "";
            }
          });
        });
      } else {
        this.searchData.channel = "";
        this.searchData.pkg = "";
        this.searchMark.channel = "";
        this.searchMark.pkg = "";
        this.searchMark.platform = "";
        this.searchpkgs = [];
        this.searchchannels = [];
        this.searchData.advChannel = "";
        this.searchData.advLocation = "";
        this.searchMark.ad_placement = "";
        this.searchMark.ad_channel = "";
        this.advchannels = [];
        this.advLocation = [];
      }
    },
    channelchange: function channelchange(id) {
      var _this4 = this;

      if (id != "") {
        searchpkg({
          channel_id: id
        }).then(function (res) {
          _this4.searchpkgs = res.data;

          _this4.searchchannels.forEach(function (item) {
            if (item.id == id) {
              _this4.searchMark.channel = item.channel_mark;
              _this4.searchData.pkg = "";
              _this4.searchMark.pkg = "";
            }
          });
        });
      } else {
        this.searchData.pkg = "";
        this.searchMark.pkg = "";
        this.searchMark.channel = "";
        this.searchData.channel = "";
        this.searchpkgs = [];
      }
    },
    pkgchange: function pkgchange(id) {
      var _this5 = this;

      if (id != "") {
        this.searchpkgs.forEach(function (item) {
          if (item.id == id) {
            _this5.searchMark.pkg = item.pkg_mark;
          }
        });
      } else {
        this.searchMark.pkg = "";
      }
    },
    advChannelchange: function advChannelchange(id) {
      var _this6 = this;

      if (id != "") {
        getadvLocation({
          advplatform_id: id
        }).then(function (res) {
          _this6.advLocation = res.data;
          _this6.searchMark.ad_channel = "";

          _this6.advchannels.forEach(function (item) {
            if (item.id == id) {
              _this6.searchMark.ad_channel = item.adv_platform_mark;
              _this6.searchData.advLocation = "";
              _this6.searchMark.ad_placement = "";
            }
          });
        });
      } else {
        this.searchData.advLocation = "";
        this.searchMark.ad_placement = "";
        this.searchMark.ad_channel = "";
        this.searchData.advChannel = "";
        this.advLocation = [];
      }
    },
    advLocationchange: function advLocationchange(id) {
      var _this7 = this;

      if (id != "") {
        this.advLocation.forEach(function (item) {
          if (item.id == id) {
            _this7.searchMark.ad_placement = item.adv_place_mark;
          }
        });
      } else {
        this.searchMark.ad_placement = "";
      }
    },
    userChange: function userChange(val) {
      this.searchMark.user_name = val;
    },
    phoneChange: function phoneChange(val) {
      this.searchMark.phone = val;
    },
    emailChange: function emailChange(val) {
      this.searchMark.email = val;
    },
    deviceChange: function deviceChange(val) {
      this.searchMark.device_id = val;
    },
    handleSource: function handleSource(id, item, num) {
      var _this8 = this;

      item.game = item.game ? item.game : this.searchMark.game, item.platform = item.platform ? item.platform : this.searchMark.platform, item.channel = item.channel ? item.channel : this.searchMark.channel;
      this.addWayConfig = true;
      this.addWayConfigEmail = false;
      this.addWayConfigPhone = false;
      this.addWayConfigInfor = false;
      this.showing = true;
      this.dialog = true;
      this.$nextTick(function () {
        _this8.$refs.addWayConfig.init(id, item, num);
      });
    },
    // 邮箱
    handleSource1: function handleSource1(id, item, num) {
      var _this9 = this;

      item.game = item.game ? item.game : this.searchMark.game, item.platform = item.platform ? item.platform : this.searchMark.platform, item.channel = item.channel ? item.channel : this.searchMark.channel;
      this.addWayConfigEmail = true;
      this.addWayConfigPhone = false;
      this.addWayConfig = false;
      this.addWayConfigInfor = false;
      this.showing = true;
      this.dialog = true;
      this.$nextTick(function () {
        _this9.$refs.addWayConfig.init(id, item, num);
      });
    },
    // 手机
    handleSource2: function handleSource2(id, item, num) {
      var _this10 = this;

      item.game = item.game ? item.game : this.searchMark.game, item.platform = item.platform ? item.platform : this.searchMark.platform, item.channel = item.channel ? item.channel : this.searchMark.channel;
      this.addWayConfigPhone = true;
      this.addWayConfigEmail = false;
      this.addWayConfig = false;
      this.addWayConfigInfor = false;
      this.showing = true;
      this.dialog = true;
      this.$nextTick(function () {
        _this10.$refs.addWayConfig.init(id, item, num);
      });
    },
    // 用户详情
    handleGetInfo: function handleGetInfo(id, item, num) {
      var _this11 = this;

      this.addWayConfigPhone = false;
      this.addWayConfigEmail = false;
      this.addWayConfig = false;
      this.addWayConfigInfor = true;
      this.showing = true;
      this.dialog = true;
      this.$nextTick(function () {
        _this11.$refs.addWayConfig.init(id, item, num);
      });
    },
    // // 新增弹窗
    // dialogShow() {
    //   this.dialog = true;
    // },
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.showing = val;
      this.dialog = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchClick();
    },
    searchClick: function searchClick() {
      var _this12 = this;

      this.page = this.searchMark.pag;
      querUserList(this.searchMark).then(function (res) {
        if (res.state == 200) {
          var list = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
          _this12.tableData = res.data.data.length ? _this12.$utils.dataConversion(res.data.data, list) : [];
          _this12.total = res.data.total || 0;
          _this12.totalShow = true;
        }
      });
    },
    // 封禁
    banHandle: function banHandle(id, userId, item, num) {
      var _this13 = this;

      var obj = {
        id: id,
        user_id: userId,
        game: item.game ? item.game : this.searchMark.game,
        platform: item.platform ? item.platform : this.searchMark.platform,
        channel: item.channel ? item.channel : this.searchMark.channel
      };

      if (num == 1) {
        this.message = "此操作将封禁该选项, 是否继续?";
      } else if (num == 2) {
        this.message = "此操作将解封该选项, 是否继续?";
      }

      this.$confirm(this.message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                banUser(obj).then(function (res) {
                  _this13.searchClick();

                  _this13.$message({
                    type: "success",
                    message: res.message
                  });
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))).catch(function () {
        _this13.$message({
          type: "info",
          message: "已取消"
        });
      });
    },
    // 重置密钥
    handleJoinPeople: function handleJoinPeople(a) {
      var _this14 = this;

      var tid = {
        id: a.id
      };
      this.$alert("<strong>\u5BC6\u94A5ID:<i>".concat(a.secret_key_id, "</i></strong></br><strong>\u5BC6\u94A5key:<i>").concat(a.secret_key_key, "</i></strong>"), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "重置"
      }).then(function () {
        restKeyId(tid).then(function (res) {
          _this14.$message({
            type: "success",
            message: res.message
          });

          _this14.searchClick();
        }).catch(function () {});
      });
    }
  }
};